// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1xTUB","errorLogs":"styles_errorLogs__3LyHr"};